import { PATH_PROGRAM_MINT_STAND_ALONE } from 'app/router/routesConfigPrograms';

const USER_FTD = 'a44067a1-52d5-11ee-940a-4d25fb80326f';
export function isFTD(user, path) {
  return user?.guid === USER_FTD && path !== PATH_PROGRAM_MINT_STAND_ALONE ? false : true;
}
